import React from 'react';
import { IStyle } from 'Styles';

interface Props {
  firstSection: React.ReactNode;
  secondSection: React.ReactNode;
}

const BaseSectionContainer = (props: Props) => {
  const { firstSection, secondSection } = props;

  return (
    <div id="basesectioncontainer-wrapper" style={styles.root}>
      <div id="basesectioncontainer-first-section" style={styles.firstSection}>
        {firstSection}
      </div>
      <div id="basesectioncontainer-second-section" style={styles.secondSection}>
        {secondSection}
      </div>
    </div>
  );
};

const styles: IStyle = {
  root: {
    display: 'flex',
    width: '100%',
    flex: 1,
    border: '2px solid #ccc',
    borderBottom: '3px solid #ccc',
    height: '100%',
  },
  firstSection: {
    width: '70%',
    minHeight: '50%',
  },
  secondSection: {
    width: '30%',
  },
};
export default BaseSectionContainer;
